/**
 * @generated SignedSource<<d4e06e35a588750e4b65585a6b8462cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appBuildNumber_AppVersionFragment$data = {
  readonly androidBuildNumber: string | null;
  readonly iosBuildNumber: string | null;
  readonly " $fragmentType": "appBuildNumber_AppVersionFragment";
};
export type appBuildNumber_AppVersionFragment$key = {
  readonly " $data"?: appBuildNumber_AppVersionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appBuildNumber_AppVersionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appBuildNumber_AppVersionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iosBuildNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "androidBuildNumber",
      "storageKey": null
    }
  ],
  "type": "AppVersion",
  "abstractKey": null
};

(node as any).hash = "f64c0ec00d75de557f51e18e7482f60c";

export default node;
